import { hmcsIcon } from "assets/icons/svgIcons";

export default [
  {
    id: "hmcs",
    title: "HMCs",
    icon: hmcsIcon,
    pageTitle: "HMCs List",
    navLink: "/hmcs",
    type: "item",
    permissions: ["super_admin"],
  },
];
